import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import info from '../components/info.vue'
import news from '../components/news.vue'
import newsDetail from '../components/newsDetail.vue'
import Search from '../components/search.vue'
import siteMap from '../components/siteMap.vue'
import link from '../components/link.vue'
import org from '../components/org.vue'
import PreviewNews from '../components/previewNews'
import page404 from '../components/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/info/:fkey/:key',
      name: 'info',
      component: info
    },
    {
      path: '/org/:igid/:key',
      name: 'org',
      component: org
    },
    {
      path: '/news/:fkey/:key',
      name: 'news',
      component: news
    },
    {
      path: '/newsDetail/:fkey/:key/:newsId',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/link',
      name: 'link',
      component: link
    },

    {
      path: '/siteMap/:igid/:key',
      name: 'siteMap',
      component: siteMap
    },
    {
      path: '/PreviewNews/:fkey/:key/:newsId/ptw=:pwnewsId',
      name: 'PreviewNews',
      component: PreviewNews
    },
    {
      path: '/page404',
      name: 'page404',
      component: page404,
      meta: {
        keepAlive: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js